export default "__VITE_ASSET__505b48a9__"